<template>
  <v-card class="mx-auto" width="300" tile>
    <v-navigation-drawer v-model="toggle" app>

    <v-sheet color="blue darken-1" class="pa-1">
      <v-avatar class="mb-1" size="64">
        <img src="@/assets/images/user.png" alt="User"/>
      </v-avatar>
      <v-list nav>
        <v-list-item link @click="ItemAction({action: 'ViewProfile'})">
          <v-list-item-content>
            <v-list-item-title class="text-h6">
              <div class="subtitle-2">{{userName}}</div>
              <div class="subtitle-2">{{nameSub}}</div>
            </v-list-item-title>
            <v-list-item-subtitle>{{ correo }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-sheet>
    <v-divider/>
      <v-list>
        <v-list-item @click="menu('home')">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Inicio</v-list-item-title>
        </v-list-item>
        <!-- *==========*==========*==========*==========*==========*==========* -->
        <span v-for="(item, index) in menuGral" :key="index">
          <v-list-item v-if="!item.group" :class="item.hidden" @click="menu(item.action)">
            <v-list-item-icon>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{item.title}}</v-list-item-title>
          </v-list-item>

          <v-list-group v-else no-action :class="item.hidden" >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{item.title}}</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item v-for="(i, index) in item.items" :key="index" link dense :class="i.hidden" @click="menu(i.action)">
              <v-list-item-subtitle dense>{{i.title}}</v-list-item-subtitle>
              <v-list-item-icon>
                <v-icon>{{i.icon}}</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-group>

        </span>
        <v-divider></v-divider>
        <v-list-item @click="menu('logout')">
          <v-list-item-action>
            <v-icon class="blanco">mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="blanco">Cerrar Sesion</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import router from '@/router'
import { Permission } from '@/mixins/permissionMain'
export default {
  mixins: [Permission],
  props: {
    toggle: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: () => ({
    permisos: null,
    permisosUser: false,
    multiple: true,
    focusable: true,
    userName: ' ',
    nameSub: ' ',
    correo: ' ',
    menuGral: [
      {
        id: 'clientes-show',
        action: 'ViewCustomers',
        icon: 'mdi-clipboard-text',
        title: 'Clientes',
        group: false,
        hidden: 'hiddenItem'
      },
      {
        id: 'clientes.precalificacion-show',
        action: 'ViewCreditPrecalificadosCustomer',
        icon: 'mdi-clipboard-text',
        title: 'Precalificacion',
        group: false,
        hidden: 'hiddenItem'
      },
      {
        id: 'precalificacion.correos.show',
        action: 'ViewPrecalificadosEmail',
        icon: 'mdi-clipboard-text',
        title: 'Correos Simulador',
        group: false,
        hidden: 'hiddenItem'
      },
      {
        id: 'configuracion',
        group: true,
        title: 'Configuraciones',
        hidden: 'hiddenItem',
        items: [
          {
            id: 'config.empresa-show',
            action: 'ViewCompany',
            icon: 'mdi-checkerboard',
            title: 'Empresa',
            hidden: 'hiddenItem'
          },
          {
            id: 'auth.roles-show',
            action: 'ViewRoles',
            icon: 'mdi-account-network',
            title: 'Roles',
            hidden: 'hiddenItem'
          },
          {
            id: 'auth.user-show',
            action: 'ViewUser',
            icon: 'mdi mdi-account',
            title: 'Usuarios',
            hidden: 'hiddenItem'
          },
          {
            id: 'config.banks-show',
            action: 'ViewBanks',
            icon: 'mdi mdi-bank',
            title: 'Bancos',
            hidden: 'hiddenItem'
          }
          /*,
          {
            id: '0204',
            action: 'ViewDeadlines',
            icon: 'mdi-checkbox-multiple-blank',
            title: 'Plazos',
            hidden: 'hiddenItem'
          }
          */
        ]
      }
    ]
  }),
  mounted () {
    this.setDataUser()
    this.PermisosMenu(JSON.parse(localStorage.getItem('permisos')), this.menuGral)
  },
  methods: {
    ...mapActions(['PostServiceLogout']),
    setDataUser () {
      const user = this.$cookies.get('user')
      this.userName = user.usuario
      this.nameSub = user.nombre
      this.correo = user.email
    },
    menu (item) {
      if (item != null) {
        if (item === 'logout') {
          this.$swal.fire({
            title: '¿Desea cerrar su sesion ?',
            text: 'Asegurese de haber concluido sus labores diarias',
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Cerrar sesion',
            cancelButtonText: 'Cancelar'
          }).then(result => {
            if (result.value) {
              this.PostServiceLogout({ url: '/auth/users/logout' })
            }
          })
        } else {
          router.push({ name: item })
        }
      }
    },
    PermisosMenuL (user) {
      if (user.descripcion) {
        if (user.descripcion.special === 'all-access') {
          this.menuGral.map(action => {
            if (action.group) {
              action.hidden = ''
              action.items.map(subItems => {
                subItems.hidden = ''
              })
            } else {
              action.hidden = ''
            }
          })
          return
        }
      }
      this.menuGral.map(action => {
        user.permisos.map(item => {
          if (action.group) {
            if (item.slug === action.id) {
              action.hidden = ''
              action.items.map(subItems => {
                user.permisos.map(per => {
                  if (per.slug === subItems.id) {
                    subItems.hidden = ''
                  }
                })
              })
            }
            // action para los sub menu
          } else {
            if (item.slug === action.id) {
              action.hidden = ''
            }
          }
        })
      })
    },
    ItemAction (item) {
      router.push({ name: item.action })
    }
  },
  computed: {
    ...mapGetters(['get_objectCloseAccess'])
  },
  watch: {
    get_objectCloseAccess (val) {
      if (val.result) {
        this.$cookies.remove('user')
        this.$cookies.remove('token_cred')
        localStorage.removeItem('permisos')
        router.push('/')
      }
    }
  }
}
</script>

<style>
.relleno {
  color: white;
  background: #bf360c;
}
.title-menu {
  color: white;
  font-size: 20px !important;
  max-width: 100% !important;
  height: 38px !important;
  text-align: center !important;
}
.user-info {
  padding: 13px 15px 12px 15px;
  white-space: nowrap;
  position: relative;
  border-bottom: 1px solid #e9e9e9;
  background: url("../../assets/images/horizontal.jpg") no-repeat no-repeat;
  height: 135px;
}
.user-info .image {
  margin-right: 12px;
  display: inline-block;
}
.user-info .image img {
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  border-radius: 50%;
  vertical-align: bottom !important;
}
.user-info .info-container .name {
  white-space: nowrap;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 14px;
  max-width: 200px;
  color: #fff;
}
.user-info .info-container .email {
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 12px;
  max-width: 200px;
  color: #fff;
}
.hiddenItem{
  display: none;
}
</style>
